import { render } from "./hotel.vue?vue&type=template&id=1d67a36a&scoped=true"
import script from "./hotel.vue?vue&type=script&lang=js"
export * from "./hotel.vue?vue&type=script&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=1d67a36a&lang=scss&scoped=true"
import "./hotel.vue?vue&type=style&index=1&id=1d67a36a&lang=scss"
script.render = render
script.__scopeId = "data-v-1d67a36a"

export default script